import { Button } from '@calendly/ui/components/button';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const settingsWrapperCss = "sf2l50h";
export const SettingsWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(settingsWrapperCss, props.className)} />;
});
const deleteDisclaimerWrapperIsPhoneCss = "d4gk6wf";
const deleteDisclaimerWrapperCss = "d9whs7n";
export const DeleteDisclaimerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(deleteDisclaimerWrapperCss, {
    [deleteDisclaimerWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
const modifiedPageContainerIsTabletUpCss = "m1xoic3h";
const modifiedPageContainerIsPhoneCss = "memzlgm";
const modifiedPageContainerCss = "mlgv9xw";
export const ModifiedPageContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(modifiedPageContainerCss, {
    [modifiedPageContainerIsTabletUpCss]: isTabletUp,
    [modifiedPageContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const disclaimerButtonCss = "d4gwig5";
export const DisclaimerButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(disclaimerButtonCss, props.className)} />);
const disclaimerButtonWrapperIsPhoneCss = "d1ilithx";
const disclaimerButtonWrapperCss = "d1m46t60";
export const DisclaimerButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(disclaimerButtonWrapperCss, {
    [disclaimerButtonWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");